(function () {
  const CONFIG = window.grGarageConfig || {};
  const STORAGE_KEY = 'gr_g_vehicles';
  const API_URL = CONFIG.apiUrl || '/apps/recon-loyalty-api';
  const VEHICLES = {
    Ford: {
      'F-150': { start: 1997, end: 2026 },
      'F-150 Lightning': { years: [2022, 2023, 2024, 2025, 2026] },
      'F-150 RAPTOR': { start: 2010, end: 2025 },
      'Superduty F-250': { start: 1999, end: 2026 },
      'Superduty F-350': { start: 1999, end: 2026 },
      'Superduty F-450': { start: 1999, end: 2026 },
      'Superduty F-550': { start: 1999, end: 2026 },
      'Superduty F-650': { start: 1999, end: 2025 },
      'Bronco': { start: 2021, end: 2025 },
      'Excursion': { start: 2000, end: 2007 },
      'Expedition': { start: 1997, end: 2013 },
      'Maverick': { years: [2022, 2023, 2024] },
      'Mustang': { start: 2005, end: 2017 },
      'Ranger': { start: 1995, end: 2026 },
      'Sport-Trac': { start: 2001, end: 2016 },
    },
    'Dodge (RAM)': {
      'RAM 1500': { start: 1994, end: 2026 },
      'RAM 1500 Classic Body': { start: 1994, end: 2025 },
      'RAM 2500': { start: 1994, end: 2026 },
      'RAM 3500': { start: 1994, end: 2026 },
    },
    Chevy: {
      'Avalanche': { start: 2007, end: 2013 },
      'Silverado 1500': { start: 1988, end: 2026 },
      'Silverado 2500': { start: 1988, end: 2025 },
      'Silverado 3500': { start: 1988, end: 2025 },
      'Silverado 3500 Dually': { start: 1988, end: 2025 },
      'Suburban': { start: 2000, end: 2026 },
      'Tahoe': { start: 2000, end: 2026 },
    },
    GMC: {
      'Sierra 1500': { start: 1994, end: 2026 },
      'Sierra 2500': { start: 1994, end: 2025 },
      'Sierra 3500': { start: 1994, end: 2025 },
      'Sierra 3500 Dually': { start: 1994, end: 2025 },
      'Yukon': { years: [2026, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002, 2001, 2000] },
      'Yukon XL': { start: 2021, end: 2026 },
      'Yukon Denali': { start: 2021, end: 2026 },
      'Hummer EV': { years: [2022, 2023, 2024, 2025] },
    },
    Jeep: {
      'Wrangler JL': { start: 2018, end: 2025 },
      'Wrangler JK': { start: 2007, end: 2018 },
      'Gladiator': { start: 2018, end: 2025 },
    },
    Toyota: {
      'Sequoia': { start: 1995, end: 2013 },
      'Tacoma': { start: 1995, end: 2026 },
      'Tundra': { start: 1995, end: 2026 },
    },
    Hummer: { 'H2': { start: 2002, end: 2010 } },
    Cadillac: { 'Escalade': { start: 2021, end: 2026 } },
  };

  function getYears({ start, end, years }) {
    if (years) return [...years].sort((a, b) => b - a);
    const r = [];
    for (let y = end; y >= start; y--) r.push(y);
    return r;
  }

  const makeEl = document.getElementById('gr_g_make');
  const modelEl = document.getElementById('gr_g_model');
  const yearEl = document.getElementById('gr_g_year');
  const addBtnEl = document.getElementById('gr_g_addBtn');
  const messageEl = document.getElementById('gr_g_message');
  const backdropEl = document.getElementById('gr_g_backdrop');
  const drawerEl = document.getElementById('gr_g_drawer');
  const indicatorWrapEl = document.getElementById('gr_g_indicator_wrap');
  const modalOverlayEl = document.getElementById('gr_g_modal_overlay');
  const modalXEl = document.getElementById('gr_g_modal_x');
  const modalCloseEl = document.getElementById('gr_g_modal_close');
  const modalBodyEl = document.getElementById('gr_g_modal_body');
  const modalLoginEl = document.getElementById('gr_g_modal_login');
  const changeOverlayEl = document.getElementById('gr_g_change_overlay');
  const changeXEl = document.getElementById('gr_g_change_x');
  const changeCloseEl = document.getElementById('gr_g_change_close');
  const changeUnselectEl = document.getElementById('gr_g_change_unselect');
  const listOverlayEl = document.getElementById('gr_g_list_overlay');
  const listXEl = document.getElementById('gr_g_list_x');
  const listBodyEl = document.getElementById('gr_g_list_body');
  const addVehicleOverlayEl = document.getElementById('gr_g_add_vehicle_overlay');
  const addVehicleXEl = document.getElementById('gr_g_add_vehicle_x');
  const addVehicleCloseEl = document.getElementById('gr_g_add_vehicle_close');

  /* ── Shared SVGs ── */
  const CAR_ICON_SVG = `<svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M2.50012 11L4.50012 11.9167M21.5001 11.4584L19.5001 11.9167M8.00012 16.0417L8.24612 15.4789C8.61112 14.6419 8.79412 14.223 9.17512 13.9865C9.55512 13.75 10.0471 13.75 11.0311 13.75H12.9691C13.9531 13.75 14.4451 13.75 14.8251 13.9865C15.2051 14.223 15.3891 14.6419 15.7551 15.4789L16.0001 16.0417M2.00012 15.5834V18.2252C2.00012 18.5726 2.24012 18.8898 2.62212 19.0447C2.86912 19.1455 3.10512 19.25 3.39112 19.25H5.10912C5.39512 19.25 5.63112 19.1455 5.87912 19.0447C6.25912 18.8898 6.50012 18.5726 6.50012 18.2252V16.5M17.5001 16.5V18.2252C17.5001 18.5726 17.7401 18.8898 18.1221 19.0447C18.3691 19.1455 18.6051 19.25 18.8911 19.25H20.6091C20.8951 19.25 21.1311 19.1455 21.3791 19.0447C21.7591 18.8898 22.0001 18.5726 22.0001 18.2252V15.5834M20.0001 7.79169L21.0001 7.33336M4.00012 7.79169L3.00012 7.33336" stroke="black" stroke-width="1.01849" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.50012 8.25008L5.58812 5.25716C6.02812 4.04716 6.24812 3.44216 6.77212 3.09658C7.29612 2.75099 7.99212 2.75008 9.38312 2.75008H14.6171C16.0081 2.75008 16.7041 2.75008 17.2271 3.09658C17.7521 3.44216 17.9721 4.04716 18.4121 5.25716L19.5001 8.25008M4.50012 8.25008H19.5001M4.50012 8.25008C3.54312 9.17958 2.00012 10.473 2.00012 11.9167V15.0976C2.00012 15.6219 2.38012 16.0619 2.88312 16.1215L6.00012 16.5001H18.0001L21.1171 16.1215C21.6201 16.0601 22.0001 15.6201 22.0001 15.0976V11.9167C22.0001 10.473 20.4571 9.17958 19.5001 8.25008" stroke="black" stroke-width="1.01849" stroke-linejoin="round"/>
    </svg>`;

  const CHECK_SVG = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M2 7.5L5.5 11L12 3" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  const TRASH_SVG = ` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9997 7.4978C14.4809 7.49782 16.8356 7.90995 18.9528 8.64819L18.2653 18.283C18.1158 20.3762 16.3737 21.9978 14.2751 21.9978H9.72433C7.62577 21.9978 5.88361 20.3762 5.73409 18.283L5.04562 8.64819C7.16294 7.90989 9.51845 7.4978 11.9997 7.4978ZM9.99972 10.2478C9.58561 10.2478 9.24989 10.5837 9.24972 10.9978V16.9978C9.24972 17.412 9.5855 17.7478 9.99972 17.7478C10.4139 17.7477 10.7497 17.412 10.7497 16.9978V10.9978C10.7495 10.5838 10.4138 10.2479 9.99972 10.2478ZM13.9997 10.2478C13.5856 10.2478 13.2499 10.5837 13.2497 10.9978V16.9978C13.2497 17.412 13.5855 17.7478 13.9997 17.7478C14.4139 17.7477 14.7497 17.412 14.7497 16.9978V10.9978C14.7495 10.5838 14.4138 10.2479 13.9997 10.2478ZM11.9997 1.99976C13.5183 1.99983 14.7495 3.23117 14.7497 4.74976V4.91577C17.1346 5.20602 19.3625 5.86818 21.3278 6.82593C21.7002 7.00738 21.855 7.4565 21.6735 7.82886C21.492 8.20102 21.0429 8.35597 20.6706 8.17456C18.1791 6.96041 15.2038 6.24978 11.9997 6.24976C8.79546 6.24976 5.81948 6.96033 3.32784 8.17456C2.95556 8.35576 2.50632 8.2011 2.32491 7.82886C2.14351 7.45662 2.29851 7.00749 2.67062 6.82593C4.6361 5.8681 6.86474 5.20602 9.24972 4.91577V4.74976C9.24989 3.23112 10.481 1.99976 11.9997 1.99976Z" fill="#EF4450"/>
    </svg>`;

  /* ── Cached API vehicles for logged-in ── */
  let _apiVehicles = [];
  let _apiTotalCount = 0;
  let _lastCollectionJsonData = null;
  const _collectionJsonFetchByUrl = new Map();
  let _garageInitSettled = false;

  const VEHICLE_FILTER_PARAMS = {
    make: 'filter.p.m.custom.make',
    model: 'filter.p.m.custom.vehicle_model',
    year: 'filter.p.m.custom.vehicle_year',
  };
  const DEFAULT_COLLECTION_PATH = '/collections/all';

  /* ── Guest replace-mode: set when "Select another vehicle" is clicked ── */
  let _replaceMode = false;

  /* ── Fetch garage listing from API ── */
  async function fetchGarageList() {
    try {
      const resp = await fetch(`${API_URL}/garage/listing`, {
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await resp.json().catch(() => ({}));
      if (resp.ok && data.statusCode === 200) {
        _apiVehicles = data.data?.vehicles || [];
        _apiTotalCount = data.data?.totalCount ?? _apiVehicles.length;
      }
    } catch (err) {
      console.warn('Garage: failed to fetch listing', err);
    }
  }

  /* ── Render indicator button ── */
  function renderVehicleIndicator() {
    if (!indicatorWrapEl) return;

    if (CONFIG.isLoggedIn) {
      _renderLoggedInIndicator();
    } else {
      _renderGuestIndicator();
    }
  }

  function _renderGuestIndicator() {
    const stored = getStoredVehicles();
    const latest = stored[stored.length - 1];

    if (!latest) {
      indicatorWrapEl.innerHTML = `
          <button class="gr_g_indicator gr_g_indicator--empty" type="button" id="gr_g_select_btn">
            <span class="gr_g_indicator-icon">${CAR_ICON_SVG}</span>
            <span class="gr_g_indicator-label">Select Your Vehicle</span>
          </button>`;
      document.getElementById('gr_g_select_btn').addEventListener('click', openDrawer);
    } else {
      const label = `${latest.year} ${latest.make} ${latest.model}`;
      const count = stored.length;
      indicatorWrapEl.innerHTML = `
          <div class="gr_g_indicator gr_g_indicator--filled">
            <span class="gr_g_indicator-icon-wrap">
              ${CAR_ICON_SVG}
            </span>
            <span class="gr_g_indicator-vehicle">${label}</span>
            <span class="gr_g_indicator-divider" aria-hidden="true"></span>
            <button class="gr_g_indicator-change" type="button" id="gr_g_change_btn">Change</button>
          </div>`;
      // indicatorWrapEl.innerHTML = `
      //   <div class="gr_g_indicator gr_g_indicator--filled">
      //     <span class="gr_g_indicator-icon-wrap">
      //       ${CAR_ICON_SVG}
      //       ${count > 0 ? `<span class="gr_g_indicator-badge">${count}</span>` : ''}
      //     </span>
      //     <span class="gr_g_indicator-vehicle">${label}</span>
      //     <span class="gr_g_indicator-divider" aria-hidden="true"></span>
      //     <button class="gr_g_indicator-change" type="button" id="gr_g_change_btn">Change</button>
      //   </div>`;
      document.getElementById('gr_g_change_btn').addEventListener('click', _openGuestChangeModal);
    }
  }

  function _renderLoggedInIndicator() {
    const defaultVehicle = _apiVehicles.find((v) => v.markAsDefault);
    const count = _apiTotalCount;

    if (!defaultVehicle) {
      // No vehicle selected — show "Select Your Vehicle" with count badge if vehicles exist
      indicatorWrapEl.innerHTML = `
          <button class="gr_g_indicator gr_g_indicator--empty" type="button" id="gr_g_select_btn">
            <span class="gr_g_indicator-icon-wrap">
              ${CAR_ICON_SVG}
              ${count > 0 ? `<span class="gr_g_indicator-badge">${count}</span>` : ''}
            </span>
            <span class="gr_g_indicator-label">Select Your Vehicle</span>
          </button>`;
      // Open list modal if vehicles exist so user can pick one, otherwise open drawer to add
      document.getElementById('gr_g_select_btn').addEventListener('click', count > 0 ? openListModal : openDrawer);
    } else {
      const label = `${defaultVehicle.year} ${defaultVehicle.make} ${defaultVehicle.model}`;
      indicatorWrapEl.innerHTML = `
          <div class="gr_g_indicator gr_g_indicator--filled">
            <span class="gr_g_indicator-icon-wrap">
              ${CAR_ICON_SVG}
              ${count > 0 ? `<span class="gr_g_indicator-badge">${count}</span>` : ''}
            </span>
            <span class="gr_g_indicator-vehicle">${label}</span>
            <span class="gr_g_indicator-divider" aria-hidden="true"></span>
            <button class="gr_g_indicator-change" type="button" id="gr_g_change_btn">Change</button>
          </div>`;
      document.getElementById('gr_g_change_btn').addEventListener('click', openListModal);
    }
  }

  /* ── Vehicle indicator BAR ── */
  const VIB_CHECK_SVG = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 7.5L5.5 11L12 3" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  function renderVehicleBar() {
    const roots = document.querySelectorAll('.gr_vib_root');
    if (!roots.length) return;
    roots.forEach((el) => {
      if (CONFIG.isLoggedIn) { _renderBarLoggedIn(el); }
      else { _renderBarGuest(el); }
    });
  }

  function renderColMakeModal() {
    const sectionRoots = new Set();
    document.querySelectorAll('.gr_col_make_vib, .gr_col_make_search').forEach((el) => {
      const section = el.closest('[id^="section-"]');
      if (section) sectionRoots.add(section);
    });
    if (!sectionRoots.size) return;

    const shouldShowVib = (() => {
      if (CONFIG.isLoggedIn) {
        const hasDefault = _apiVehicles.some((v) => v.markAsDefault);
        return _apiVehicles.length > 0 && hasDefault;
      }
      return getStoredVehicles().length > 0;
    })();

    sectionRoots.forEach((section) => {
      const vibWrap = section.querySelector('.gr_col_make_vib');
      const searchWrap = section.querySelector('.gr_col_make_search');

      section.classList.remove('gr_col_make_pending');

      if (shouldShowVib) {
        if (vibWrap) vibWrap.style.display = '';
        if (searchWrap) searchWrap.style.display = 'none';
      } else {
        if (vibWrap) vibWrap.style.display = 'none';
        if (searchWrap) searchWrap.style.display = '';
      }
    });
  }

  function _hideBar(el) {
    el.innerHTML = '';
    el.style.display = 'none';
  }

  function _renderBarFilled(el, { label, count, onChangeFn, onAddFn = openDrawer, showAdd = true }) {
    // const badge = count > 1 ? `<span class="gr_vib_badge">${count}</span>` : '';
    const addBtn = showAdd ? `
        <button class="gr_vib_btn gr_vib_btn--add" type="button" data-gr-vib="add">
          <span class="gr_vib_label-full">Add Vehicle</span>
          <span class="gr_vib_label-short">Add</span>
        </button>` : '';
    el.style.display = '';
    el.innerHTML = `
        <div class="gr_vib_bar">
          <div class="gr_vib_left">
            <span class="gr_vib_check">${VIB_CHECK_SVG}</span>
            <div class="gr_vib_name-wrap">
              <span class="gr_vib_name-label">Selected Vehicle</span>
              <span class="gr_vib_name">${label}</span>
            </div>
          </div>
          <div class="gr_vib_right">
            <button class="gr_vib_btn gr_vib_btn--change" type="button" data-gr-vib="change">
              <span class="gr_vib_label-full">Change Vehicle</span>
              <span class="gr_vib_label-short">Change</span>
            </button>
            ${addBtn}
          </div>
        </div>`;
    el.querySelector('[data-gr-vib="change"]').addEventListener('click', onChangeFn);
    if (showAdd) el.querySelector('[data-gr-vib="add"]').addEventListener('click', onAddFn);
  }

  function _renderBarGuest(el) {
    const stored = getStoredVehicles();
    const latest = stored[stored.length - 1];

    if (!latest) {
      _renderBarNoSelection(el, {
        onSelectFn: openDrawer,
        showAdd: false,
      });
      return;
    }

    _renderBarFilled(el, {
      label: `${latest.year} ${latest.make} ${latest.model}`,
      count: stored.length,
      onChangeFn: _openGuestChangeModal,
      onAddFn: _openGuestAddModal,
      showAdd: true,
    });
  }

  function _renderBarNoSelection(el, { onSelectFn, onAddFn = openDrawer, showAdd = true }) {
    const addBtn = showAdd ? `
        <button class="gr_vib_btn gr_vib_btn--add" type="button" data-gr-vib="add">
          <span class="gr_vib_label-full">Add Vehicle</span>
          <span class="gr_vib_label-short">Add</span>
        </button>` : '';
    el.style.display = '';
    el.innerHTML = `
        <div class="gr_vib_bar gr_vib_bar--no-selection">
          <div class="gr_vib_left">
            <div class="gr_vib_name-wrap">
              <span class="gr_vib_name">Select Your Vehicle</span>
            </div>
          </div>
          <div class="gr_vib_right">
            <button class="gr_vib_btn gr_vib_btn--change" type="button" data-gr-vib="change">
              <span class="gr_vib_label-full">Select Vehicle</span>
              <span class="gr_vib_label-short">Select</span>
            </button>
            ${addBtn}
          </div>
        </div>`;
    el.querySelector('[data-gr-vib="change"]').addEventListener('click', onSelectFn);
    if (showAdd) el.querySelector('[data-gr-vib="add"]').addEventListener('click', onAddFn);
  }

  function _renderBarLoggedIn(el) {
    const defaultVehicle = _apiVehicles.find((v) => v.markAsDefault);
    const count = _apiTotalCount;

    if (!defaultVehicle) {
      _renderBarNoSelection(el, {
        onSelectFn: count > 0 ? openListModal : openDrawer,
        showAdd: true,
      });
      return;
    }

    _renderBarFilled(el, {
      label: `${defaultVehicle.year} ${defaultVehicle.make} ${defaultVehicle.model}`,
      count,
      onChangeFn: openListModal,
      showAdd: true,
    });
  }

  /* ── Guest: Change Vehicle modal ── */
  function _openGuestChangeModal() {
    if (changeOverlayEl) changeOverlayEl.classList.add('gr_g_show');
  }
  function _closeGuestChangeModal() {
    if (changeOverlayEl) changeOverlayEl.classList.remove('gr_g_show');
    if (typeof window.closeOverlay === 'function') window.closeOverlay();
  }

  function _unsetGuestVehicle() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
      console.warn('Garage: failed to clear guest vehicle', err);
    }

    _replaceMode = false;
    _lastCollectionJsonData = null;
    _closeGuestChangeModal();
    renderAll();
    notifyVehicleCleared();
    initCollectionLinkFiltersOnPageLoad().catch((err) => {
      console.error('[grGarage] initCollectionLinkFiltersOnPageLoad failed after guest unselect', err);
    });
  }

  if (changeXEl) changeXEl.addEventListener('click', _closeGuestChangeModal);
  if (changeCloseEl) changeCloseEl.addEventListener('click', () => {
    _closeGuestChangeModal();
    _replaceMode = true;
    openDrawer();
  });
  if (changeUnselectEl) changeUnselectEl.addEventListener('click', _unsetGuestVehicle);
  if (changeOverlayEl) {
    changeOverlayEl.addEventListener('click', (e) => {
      if (e.target === changeOverlayEl) _closeGuestChangeModal();
    });
  }

  /* ── Guest: Add Vehicle modal (shown when a vehicle already exists in localStorage) ── */
  function _openGuestAddModal() {
    if (addVehicleOverlayEl) addVehicleOverlayEl.classList.add('gr_g_show');
  }
  function _closeGuestAddModal() {
    if (addVehicleOverlayEl) addVehicleOverlayEl.classList.remove('gr_g_show');
    if (typeof window.closeOverlay === 'function') window.closeOverlay();
  }
  if (addVehicleXEl) addVehicleXEl.addEventListener('click', _closeGuestAddModal);
  if (addVehicleCloseEl) addVehicleCloseEl.addEventListener('click', _closeGuestAddModal);
  if (addVehicleOverlayEl) {
    addVehicleOverlayEl.addEventListener('click', (e) => {
      if (e.target === addVehicleOverlayEl) _closeGuestAddModal();
    });
  }

  /* ── Logged-in: Garage list modal ── */
  function openListModal() {
    _renderGarageList();
    if (listOverlayEl) listOverlayEl.classList.add('gr_g_show');
  }

  function closeListModal() {
    if (listOverlayEl) listOverlayEl.classList.remove('gr_g_show');
    if (typeof window.closeOverlay === 'function') window.closeOverlay();
  }

  if (listXEl) listXEl.addEventListener('click', closeListModal);
  if (listOverlayEl) {
    listOverlayEl.addEventListener('click', (e) => {
      if (e.target === listOverlayEl) closeListModal();
    });
  }

  const GARAGE_PAGE_URL = '/pages/my-garage';
  const MAX_LIST_VEHICLES = 5;

  function _renderGarageList() {
    if (!listBodyEl) return;

    const visible = _apiVehicles.slice(0, MAX_LIST_VEHICLES);
    const hasMore = _apiTotalCount > MAX_LIST_VEHICLES;

    const cards = visible
      .map((v) => {
        const isDefault = v.markAsDefault;
        return `
          <div class="gr_g_vcard ${isDefault ? 'gr_g_vcard--selected' : ''}" data-id="${v.id}">
            <div class="gr_g_vcard-top">
              <div class="gr_g_vcard-check">${isDefault ? CHECK_SVG : ''}</div>
              <div class="gr_g_vcard-name">${v.year} ${v.make} ${v.model}</div>
              <button class="gr_g_vcard-delete" type="button" data-action="delete" data-id="${v.id}" aria-label="Delete vehicle">
                ${TRASH_SVG}
              </button>
            </div>
            <button class="gr_g_vcard-btn ${isDefault ? 'gr_g_vcard-btn--selected' : 'gr_g_vcard-btn--select'}"
              type="button"
              data-action="${isDefault ? 'unselect' : 'select'}"
              data-id="${v.id}"
            >
              ${isDefault ? 'Unselect This Vehicle' : 'Select This Vehicle'}
            </button>
          </div>`;
      })
      .join('');

    const addCard = `
        <div class="gr_g_vcard gr_g_vcard--add">
          ${CAR_ICON_SVG}
          <button class="gr_g_vcard-btn gr_g_vcard-btn--add" type="button" data-action="add-new">
            Add Vehicle
          </button>
        </div>`;

    const viewAllLink = `<a class="gr_g_list-view-all" href="${GARAGE_PAGE_URL}">View My Garage</a>`;

    // const viewAllLink = hasMore
    //   ? `<a class="gr_g_list-view-all" href="${GARAGE_PAGE_URL}">View My Garage</a>`
    //   : '';
    // const viewAllLink = hasMore
    //   ? `<a class="gr_g_list-view-all" href="${GARAGE_PAGE_URL}">View all ${_apiTotalCount} vehicles</a>`
    //   : '';

    listBodyEl.innerHTML = cards + addCard + viewAllLink;

    listBodyEl.querySelectorAll('[data-action]').forEach((el) => {
      el.addEventListener('click', _handleListAction);
    });
  }

  async function _handleListAction(e) {
    const btn = e.currentTarget;
    const action = btn.getAttribute('data-action');
    const id = btn.getAttribute('data-id');

    if (action === 'select') {
      await _setDefaultVehicle(id, btn);
    } else if (action === 'unselect') {
      await _unsetDefaultVehicle(id, btn);
    } else if (action === 'delete') {
      await _deleteVehicle(id, btn);
    } else if (action === 'add-new') {
      closeListModal();
      openDrawer();
    }
  }

  async function _findVehicleByYmm({ make, model, year }) {
    let match = _apiVehicles.find(
      (v) => v.make === make && v.model === model && String(v.year) === String(year)
    );
    if (!match) {
      await fetchGarageList();
      match = _apiVehicles.find(
        (v) => v.make === make && v.model === model && String(v.year) === String(year)
      );
    }
    return match || null;
  }

  async function _markVehicleAsSelected(id) {
    const resp = await fetch(`${API_URL}/garage/mark-as-selected`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ vehicleId: id, markAsDefault: true }),
    });
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok || (data.statusCode && data.statusCode !== 200)) {
      throw new Error(data.message || 'Failed to select vehicle.');
    }
    _apiVehicles = _apiVehicles.map((v) => ({ ...v, markAsDefault: v.id === id }));
    return _apiVehicles.find((v) => v.id === id) || null;
  }

  async function _selectExistingVehicle(vehicle) {
    const existing = await _findVehicleByYmm(vehicle);
    if (!existing?.id) {
      throw new Error('Vehicle exists but could not be found in your garage.');
    }
    const selected = await _markVehicleAsSelected(existing.id);
    renderAll();
    _renderGarageList();
    return selected || existing;
  }

  async function _setDefaultVehicle(id, btn) {
    if (btn) {
      btn.disabled = true;
      btn.classList.add('gr_g_vcard-btn--loading');
      btn.textContent = 'Selecting...';
    }
    try {
      const resp = await fetch(`${API_URL}/garage/mark-as-selected`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vehicleId: id, markAsDefault: true }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || (data.statusCode && data.statusCode !== 200)) throw new Error(data.message);
      _apiVehicles = _apiVehicles.map((v) => ({ ...v, markAsDefault: v.id === id }));
      _renderGarageList();
      _renderLoggedInIndicator();
      renderVehicleBar();
      renderCompatibilityBanners();
      const selected = _apiVehicles.find((v) => v.id === id);

      if (selected) {
        closeListModal();
        await syncCollectionJsonDataOnVehicleSelection(selected, { redirect: true });
      }
    } catch (err) {
      console.error('Garage: set-default failed', err);
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('gr_g_vcard-btn--loading');
        btn.textContent = 'Select This Vehicle';
      }
    }
  }

  async function _unsetDefaultVehicle(id, btn) {
    if (btn) {
      btn.disabled = true;
      btn.classList.add('gr_g_vcard-btn--loading');
      btn.textContent = 'Unselecting...';
    }
    try {
      const resp = await fetch(`${API_URL}/garage/mark-as-selected`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vehicleId: id, markAsDefault: false }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || (data.statusCode && data.statusCode !== 200)) throw new Error(data.message);
      await fetchGarageList();
      _renderGarageList();
      renderAll();
      notifyVehicleCleared();
    } catch (err) {
      console.error('Garage: unset-default failed', err);
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('gr_g_vcard-btn--loading');
        btn.textContent = 'Unselect This Vehicle';
      }
    }
  }

  async function _deleteVehicle(id, btn) {
    if (btn) {
      btn.disabled = true;
      btn.classList.add('gr_g_vcard-delete--loading');
    }
    try {
      const resp = await fetch(`${API_URL}/garage/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ vehicleId: id }),
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || (data.statusCode && data.statusCode !== 200)) throw new Error(data.message);

      await fetchGarageList();
      _renderGarageList();
      renderAll();

      if (!getSelectedVehicle()) notifyVehicleCleared();

      if (_apiVehicles.length === 0) closeListModal();
    } catch (err) {
      console.error('Garage: delete failed', err);
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('gr_g_vcard-delete--loading');
      }
    }
  }

  let _lastSavedVehicle = null;

  function getSelectedVehicle() {
    if (CONFIG.isLoggedIn) {
      const selected = _apiVehicles.find((v) => v.markAsDefault);
      return selected
        ? { make: selected.make, model: selected.model, year: String(selected.year) }
        : null;
    }
    const stored = getStoredVehicles();
    const latest = stored[stored.length - 1];
    return latest
      ? { make: latest.make, model: latest.model, year: String(latest.year) }
      : null;
  }

  function notifyVehicleCleared() {
    document.dispatchEvent(new CustomEvent('gr:vehicle-cleared'));
  }

  function appendVehicleToCollectionUrl(url, vehicle) {
    if (!url || !vehicle?.make || !vehicle?.model || !vehicle?.year) return url;

    try {
      const isAbsolute = /^https?:\/\//i.test(url);
      const isProtocolRelative = url.startsWith('//');
      const parsed = new URL(url, window.location.origin);

      if (!parsed.pathname.includes('/collections/')) return url;

      parsed.searchParams.set('filter.p.m.custom.make', vehicle.make);
      parsed.searchParams.set('filter.p.m.custom.vehicle_model', vehicle.model);
      parsed.searchParams.set('filter.p.m.custom.vehicle_year', String(vehicle.year));

      if (isAbsolute) return parsed.toString();
      if (isProtocolRelative) return `//${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      return url;
    }
  }

  function buildFilterUrl(vehicle, collectionPath = DEFAULT_COLLECTION_PATH) {
    return appendVehicleToCollectionUrl(collectionPath, vehicle);
  }

  function getCollectionFilterData() {
    if (_lastCollectionJsonData?.selectedFilters) return _lastCollectionJsonData.selectedFilters;
    const el = document.getElementById('collection-json-data');
    if (!el) return null;
    return parseCollectionJsonDataAttributes(el).selectedFilters;
  }

  function shouldAppendVehicleFiltersToLinks() {
    return !!getSelectedVehicle();
  }

  function resolveVehicleCollectionRedirectUrl(vehicle, selectedFilters, collectionPath = DEFAULT_COLLECTION_PATH) {
    if (!vehicle?.make || !vehicle?.model || !vehicle?.year) {
      return collectionPath;
    }
    return buildFilterUrl(vehicle, collectionPath);
  }

  function navigateToVehicleCollectionUrl(url) {
    if (!url) return;
    const target = new URL(url, window.location.origin);
    const targetPath = target.pathname + target.search;
    const currentPath = window.location.pathname + window.location.search;
    if (currentPath !== targetPath) window.location.href = url;
  }

  function getCollectionJsonSectionId() {
    return document.getElementById('gr-collection-fetch-meta')?.dataset?.sectionId || null;
  }

  function getProductGridSectionId() {
    const fromGrid = document.getElementById('product-grid')?.dataset?.id;
    if (fromGrid) {
      try {
        localStorage.setItem('gr_product_grid_section_id', fromGrid);
      } catch (err) {
        /* ignore */
      }
      return fromGrid;
    }

    try {
      return localStorage.getItem('gr_product_grid_section_id');
    } catch (err) {
      /* ignore */
    }

    return null;
  }

  function buildCollectionDataFetchUrl(vehicle, collectionPath = DEFAULT_COLLECTION_PATH) {
    const path = collectionPath || DEFAULT_COLLECTION_PATH;
    const filterUrl = buildFilterUrl(vehicle, path);
    const parsed = new URL(filterUrl, window.location.origin);
    const search = parsed.search.slice(1);
    const sectionId = getCollectionJsonSectionId();

    if (sectionId) {
      return `${path}?section_id=${sectionId}${search ? `&${search}` : ''}`;
    }

    return filterUrl;
  }

  function getPageLoadCollectionPath() {
    return window.location.pathname.includes('/collections/')
      ? window.location.pathname
      : null;
  }

  function isUniversalFitCollectionPage(path = window.location.pathname) {
    return String(path || '').includes('/universal-fit');
  }

  function buildPageLoadCollectionFetchUrl() {
    const path = getPageLoadCollectionPath();
    if (!path) return null;

    const sectionId = getCollectionJsonSectionId();
    const search = window.location.search.slice(1);

    if (sectionId) {
      return `${path}?section_id=${sectionId}${search ? `&${search}` : ''}`;
    }

    return `${path}${window.location.search}`;
  }

  async function fetchCollectionJsonFromUrl(fetchUrl, { updateLiveDom = true } = {}) {
    if (_collectionJsonFetchByUrl.has(fetchUrl)) {
      return _collectionJsonFetchByUrl.get(fetchUrl);
    }

    const promise = (async () => {
      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const fetchedEl = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById('collection-json-data');
        const data = parseCollectionJsonDataAttributes(fetchedEl);

        console.log('[grGarage] fetchCollectionJsonFromUrl', {
          fetchUrl,
          targetFound: !!fetchedEl,
          updateLiveDom,
          dataSelectedFilters: data.selectedFilters,
          dataProducts: data.products,
        });

        _lastCollectionJsonData = data;

        if (updateLiveDom) {
          const liveEl = document.getElementById('collection-json-data');
          if (liveEl && fetchedEl) {
            const filtersRaw = fetchedEl.getAttribute('data-selected-filters');
            const productsRaw = fetchedEl.getAttribute('data-products');
            if (filtersRaw != null) liveEl.setAttribute('data-selected-filters', filtersRaw);
            if (productsRaw != null) liveEl.setAttribute('data-products', productsRaw);
          }
        }

        return data;
      } catch (err) {
        console.error('Garage: fetchCollectionJsonFromUrl failed', err);
        return { selectedFilters: null, products: null, error: err };
      }
    })().finally(() => {
      _collectionJsonFetchByUrl.delete(fetchUrl);
    });

    _collectionJsonFetchByUrl.set(fetchUrl, promise);
    return promise;
  }

  async function fetchCollectionJsonDataForPageLoad() {
    const path = getPageLoadCollectionPath();
    if (!path) return { selectedFilters: null, products: null };

    const vehicle = getSelectedVehicle();
    const fetchUrl = vehicle && !urlHasVehicleFilterParams()
      ? buildCollectionDataFetchUrl(vehicle, path)
      : buildPageLoadCollectionFetchUrl();

    return fetchCollectionJsonFromUrl(fetchUrl, { updateLiveDom: true });
  }

  async function fetchCollectionJsonData(vehicle, { collectionPath = DEFAULT_COLLECTION_PATH, updateLiveDom = true } = {}) {
    if (!vehicle?.make || !vehicle?.model || !vehicle?.year) {
      return { selectedFilters: null, products: null };
    }

    const fetchUrl = buildCollectionDataFetchUrl(vehicle, collectionPath);
    return fetchCollectionJsonFromUrl(fetchUrl, { updateLiveDom });
  }

  function parseCollectionJsonDataAttributes(el) {
    if (!el) return { selectedFilters: null, products: null };

    const parseJsonAttr = (raw) => {
      if (!raw) return null;
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed.filter((item) => item && Object.keys(item).length > 0);
        }
        return parsed;
      } catch (err) {
        console.warn('Garage: failed to parse collection JSON attribute', err);
        return null;
      }
    };

    return {
      selectedFilters: parseJsonAttr(el.getAttribute('data-selected-filters')),
      products: parseJsonAttr(el.getAttribute('data-products')),
    };
  }

  function parseCollectionJsonDataFromHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return parseCollectionJsonDataAttributes(doc.getElementById('collection-json-data'));
  }

  async function syncCollectionJsonDataOnVehicleSelection(vehicle, { redirect = false } = {}) {
    const selectedVehicle = vehicle || getSelectedVehicle();
    if (!selectedVehicle) return { selectedFilters: null, products: null };

    const data = await fetchCollectionJsonData(selectedVehicle, {
      collectionPath: DEFAULT_COLLECTION_PATH,
    });
    const redirectUrl = resolveVehicleCollectionRedirectUrl(
      selectedVehicle,
      data.selectedFilters,
      DEFAULT_COLLECTION_PATH
    );

    const result = { ...data, redirectUrl };

    console.log('[grGarage] syncCollectionJsonDataOnVehicleSelection', result);

    applyVehicleFiltersToLinks();
    document.dispatchEvent(new CustomEvent('gr:collection-json-data', { detail: result }));

    if (redirect) navigateToVehicleCollectionUrl(redirectUrl);

    return result;
  }

  function urlHasVehicleFilterParams() {
    const params = new URLSearchParams(window.location.search);
    return Object.values(VEHICLE_FILTER_PARAMS).some((key) => params.has(key));
  }

  const NO_PARTS_FIT_MESSAGE = 'No Parts Fit Your Truck';
  let _syncUniversalProductsPromise = null;
  let _resolvedUniversalCollectionPath = null;

  function getCollectionHandleFromPath(path = window.location.pathname) {
    const match = String(path || '').match(/^\/collections\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getCollectionBasePath() {
    const handle = getCollectionHandleFromPath();
    return handle ? `/collections/${handle}` : null;
  }

  function getUniversalCollectionPathCandidates(basePath = getCollectionBasePath()) {
    if (!basePath) return [];

    if (basePath.endsWith('/universal-fit')) {
      return [basePath];
    }

    const handle = getCollectionHandleFromPath(basePath);
    if (!handle || handle === 'all') return [];

    return [`/collections/${handle}/universal-fit`];
  }

  function getUniversalCollectionPath(basePath = getCollectionBasePath()) {
    if (_resolvedUniversalCollectionPath) return _resolvedUniversalCollectionPath;

    const candidates = getUniversalCollectionPathCandidates(basePath);
    return candidates[0] || null;
  }

  function stripVehicleFilterParamsFromSearch(search = '') {
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    Object.values(VEHICLE_FILTER_PARAMS).forEach((key) => params.delete(key));
    return params.toString();
  }

  function buildSectionFetchUrl(collectionPath, sectionId, search = '') {
    if (!collectionPath || !sectionId) return null;
    return `${collectionPath}?section_id=${sectionId}${search ? `&${search}` : ''}`;
  }

  function getUniversalJsonSectionId() {
    return document.getElementById('gr-universal-fetch-meta')?.dataset?.sectionId || null;
  }

  function buildUniversalJsonFetchUrl(collectionPath) {
    const sectionId = getUniversalJsonSectionId();
    if (!collectionPath || !sectionId) return null;
    return buildSectionFetchUrl(collectionPath, sectionId);
  }

  function parseUniversalJsonDataAttributes(el) {
    if (!el) return { products: [], productsCount: 0 };

    const productsCount = Math.max(0, Number(el.getAttribute('data-products-count')) || 0);
    const raw = el.getAttribute('data-products');

    if (!raw) return { products: [], productsCount };

    try {
      const parsed = JSON.parse(raw);
      return {
        products: Array.isArray(parsed)
          ? parsed.filter((item) => item && Object.keys(item).length > 0)
          : [],
        productsCount,
      };
    } catch (err) {
      console.warn('Garage: failed to parse universal JSON attribute', err);
      return { products: [], productsCount };
    }
  }

  function parseUniversalProductsFromHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return parseUniversalJsonDataAttributes(doc.getElementById('universal-json-data'));
  }

  function getLiveCollectionJsonDataFromDom() {
    const el = document.getElementById('collection-json-data');
    return el ? parseCollectionJsonDataAttributes(el) : { selectedFilters: null, products: null };
  }

  async function fetchUniversalCollectionJson(basePath = getCollectionBasePath()) {
    const candidates = getUniversalCollectionPathCandidates(basePath);
    if (!candidates.length) return { products: [], productsCount: 0, universalPath: null };

    let lastResult = { products: [], productsCount: 0, universalPath: null };

    for (const candidatePath of candidates) {
      const fetchUrl = buildUniversalJsonFetchUrl(candidatePath);
      if (!fetchUrl) continue;

      if (_collectionJsonFetchByUrl.has(fetchUrl)) {
        const cached = await _collectionJsonFetchByUrl.get(fetchUrl);
        if (cached.products?.length || cached.productsCount > 0) {
          _resolvedUniversalCollectionPath = candidatePath;
          return { ...cached, universalPath: candidatePath };
        }
        lastResult = { ...cached, universalPath: candidatePath };
        continue;
      }

      const promise = (async () => {
        try {
          const response = await fetch(fetchUrl);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = await response.text();
          const data = parseUniversalProductsFromHtml(html);

          console.log('[grGarage] fetchUniversalCollectionJson', {
            fetchUrl,
            productCount: data.products?.length || 0,
            productsCount: data.productsCount || 0,
          });

          return data;
        } catch (err) {
          console.error('Garage: fetchUniversalCollectionJson failed', err);
          return { products: [], productsCount: 0, error: err };
        }
      })().finally(() => {
        _collectionJsonFetchByUrl.delete(fetchUrl);
      });

      _collectionJsonFetchByUrl.set(fetchUrl, promise);
      const data = await promise;

      lastResult = { ...data, universalPath: candidatePath };

      if (data.products?.length || data.productsCount > 0) {
        _resolvedUniversalCollectionPath = candidatePath;
        return lastResult;
      }
    }

    if (lastResult.universalPath) {
      _resolvedUniversalCollectionPath = lastResult.universalPath;
    }

    return lastResult;
  }

  function dedupeProductsByHandle(products) {
    const seen = new Set();
    const merged = [];

    for (const product of Array.isArray(products) ? products : []) {
      const handle = String(product?.handle || '').toLowerCase();
      if (!handle || seen.has(handle)) continue;
      seen.add(handle);
      merged.push(product);
    }

    return merged;
  }

  function extractProductHandlesFromElement(root) {
    const handles = new Set();

    root?.querySelectorAll('a[href*="/products/"]').forEach((anchor) => {
      const match = anchor.getAttribute('href')?.match(/\/products\/([^/?#]+)/i);
      if (match?.[1]) handles.add(match[1].toLowerCase());
    });

    return handles;
  }

  function countVisibleGridProducts() {
    const grid = document.getElementById('product-grid');
    if (!grid) return 0;
    return grid.querySelectorAll('.grid-item').length;
  }

  function updateProductCountDisplay(totalCount) {
    const el = document.getElementById('ProductCount');
    if (!el) return;

    const count = Math.max(0, Number(totalCount) || 0);

    if (!el.dataset.grCountPattern) {
      el.dataset.grCountPattern = el.textContent.trim().replace(/\d[\d,.]*/g, '{{count}}');
    }

    let label = el.dataset.grCountPattern.replace(/\{\{count\}\}/g, String(count));

    if (count === 1) {
      label = label.replace(/\bProducts\b/g, 'Product');
    } else {
      label = label.replace(/\bProduct\b/g, 'Products');
    }

    el.textContent = label;
    el.classList.remove('loading');
  }

  function getVehicleProductCountForSync(fallbackCount = 0) {
    const el = document.getElementById('ProductCount');
    if (!el) return Math.max(0, Number(fallbackCount) || 0);

    if (el.dataset.grInitialVehicleCount) {
      return Math.max(0, Number(el.dataset.grInitialVehicleCount) || 0);
    }

    const match = el.textContent.trim().match(/\d[\d,.]*/);
    const parsed = match ? Number(match[0].replace(/,/g, '')) : 0;
    const count = parsed > 0 ? parsed : Math.max(0, Number(fallbackCount) || 0);

    if (count > 0) el.dataset.grInitialVehicleCount = String(count);
    return count;
  }

  function computeMergedProductCount({ vehicleProductCount = 0, universalProductsCount = 0 } = {}) {
    const vehicleCount = Math.max(0, Number(vehicleProductCount) || 0);
    const universalCount = Math.max(0, Number(universalProductsCount) || 0);

    if (vehicleCount > 0 && universalCount > 0) return vehicleCount + universalCount;
    if (universalCount > 0) return universalCount;
    return vehicleCount;
  }

  function finalizeCollectionPageSync(pageData, vehicleProducts, universalProducts, countOptions = {}) {
    const totalCount = computeMergedProductCount(countOptions);
    const merged = updateMergedCollectionJsonData(pageData, vehicleProducts, universalProducts, totalCount);

    updateProductCountDisplay(totalCount);
    renderCompatibilityBanners(document.getElementById('ProductGridContainer'));

    return merged;
  }

  async function fetchProductGridSectionHtml(collectionPath, { includePageFilters = true } = {}) {
    const sectionId = getProductGridSectionId();
    if (!sectionId || !collectionPath) return null;

    const isUniversalPath = collectionPath.includes('universal-fit');
    const search = includePageFilters && !isUniversalPath
      ? window.location.search.slice(1)
      : stripVehicleFilterParamsFromSearch(window.location.search.slice(1));

    const fetchUrl = buildSectionFetchUrl(collectionPath, sectionId, search);

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) return null;
      return response.text();
    } catch (err) {
      console.error('Garage: fetchProductGridSectionHtml failed', err);
      return null;
    }
  }

  function renderNoPartsFitEmptyState(sectionId) {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    container.innerHTML = `
      <div id="product-grid" class="collection collection-empty gr_g-collection-no-parts" data-id="${sectionId || ''}">
        <h2>${NO_PARTS_FIT_MESSAGE}</h2>
      </div>
    `;
  }

  function appendUniversalGridItemsFromHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sourceGrid = doc.getElementById('product-grid');
    const targetGrid = document.getElementById('product-grid');
    if (!sourceGrid || !targetGrid) return 0;

    const existingHandles = extractProductHandlesFromElement(targetGrid);
    let appended = 0;

    sourceGrid.querySelectorAll('.grid-item').forEach((item) => {
      const itemHandles = extractProductHandlesFromElement(item);
      const handle = itemHandles.values().next().value;
      if (!handle || existingHandles.has(handle)) return;

      existingHandles.add(handle);
      targetGrid.appendChild(item.cloneNode(true));
      appended += 1;
    });

    if (appended > 0) {
      targetGrid.closest('.collection')?.classList.remove('collection-empty');
      targetGrid.classList.remove('collection-empty');
    }

    return appended;
  }

  async function replaceGridWithUniversalProducts(universalPath) {
    const html = await fetchProductGridSectionHtml(universalPath);
    if (!html) return false;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextContainer = doc.getElementById('ProductGridContainer');
    const container = document.getElementById('ProductGridContainer');
    if (!nextContainer || !container) return false;

    container.innerHTML = nextContainer.innerHTML;
    return countVisibleGridProducts() > 0;
  }

  function updateMergedCollectionJsonData(pageData, vehicleProducts, universalProducts, totalCount = null) {
    const merged = dedupeProductsByHandle([
      ...(Array.isArray(vehicleProducts) ? vehicleProducts : []),
      ...(Array.isArray(universalProducts) ? universalProducts : []),
    ]);

    const mergedCount = totalCount != null ? totalCount : merged.length;

    const nextData = {
      ...(pageData || _lastCollectionJsonData || {}),
      products: merged,
    };

    _lastCollectionJsonData = nextData;

    const liveEl = document.getElementById('collection-json-data');
    if (liveEl) {
      liveEl.setAttribute('data-products', JSON.stringify(merged));
      liveEl.setAttribute('data-products-count', String(mergedCount));
    }

    document.dispatchEvent(new CustomEvent('gr:collection-json-data', { detail: nextData }));
    return merged;
  }

  async function syncCollectionPageWithUniversalProducts() {
    if (!getPageLoadCollectionPath()) return;
    if (!getSelectedVehicle()) return;
    if (isUniversalFitCollectionPage()) return;

    const basePath = getCollectionBasePath();
    if (!basePath) return;

    _resolvedUniversalCollectionPath = null;

    const pageData = getLiveCollectionJsonDataFromDom();
    const universalData = await fetchUniversalCollectionJson(basePath);
    const universalProducts = Array.isArray(universalData?.products) ? universalData.products : [];
    const universalProductsCount = universalData?.productsCount || universalProducts.length;
    const universalPath = universalData.universalPath || getUniversalCollectionPath(basePath);
    const domVehicleCount = countVisibleGridProducts();
    const vehicleProductCount = getVehicleProductCountForSync(domVehicleCount);
    const hasVehicleProducts = vehicleProductCount > 0 || domVehicleCount > 0;
    const hasUniversalProducts = universalProductsCount > 0 || universalProducts.length > 0;
    const sectionId = getProductGridSectionId();

    console.log('[grGarage] syncCollectionPageWithUniversalProducts', {
      basePath,
      universalPath,
      domVehicleCount,
      vehicleProductCount,
      universalProductCount: universalProducts.length,
      universalProductsCount,
      universalSectionId: getUniversalJsonSectionId(),
    });

    if (!hasVehicleProducts && !hasUniversalProducts) {
      renderNoPartsFitEmptyState(sectionId);
      updateMergedCollectionJsonData(pageData, [], []);
      updateProductCountDisplay(0);
      renderCompatibilityBanners(document.getElementById('ProductGridContainer'));
      return;
    }

    if (!hasVehicleProducts && hasUniversalProducts && universalPath) {
      const replaced = await replaceGridWithUniversalProducts(universalPath);
      if (!replaced) {
        renderNoPartsFitEmptyState(sectionId);
        updateMergedCollectionJsonData(pageData, [], []);
        updateProductCountDisplay(0);
        renderCompatibilityBanners(document.getElementById('ProductGridContainer'));
        return;
      }

      finalizeCollectionPageSync(pageData, [], universalProducts, {
        vehicleProductCount: 0,
        universalProductsCount,
      });
      return;
    }

    if (hasUniversalProducts && universalPath) {
      const universalGridHtml = await fetchProductGridSectionHtml(universalPath, {
        includePageFilters: false,
      });
      if (universalGridHtml) appendUniversalGridItemsFromHtml(universalGridHtml);
    }

    finalizeCollectionPageSync(pageData, pageData.products || [], universalProducts, {
      vehicleProductCount,
      universalProductsCount,
    });
  }

  function scheduleSyncCollectionPageWithUniversalProducts() {
    if (_syncUniversalProductsPromise) return _syncUniversalProductsPromise;

    _syncUniversalProductsPromise = syncCollectionPageWithUniversalProducts()
      .catch((err) => {
        console.error('[grGarage] syncCollectionPageWithUniversalProducts failed', err);
      })
      .finally(() => {
        _syncUniversalProductsPromise = null;
      });

    return _syncUniversalProductsPromise;
  }

  async function initCollectionLinkFiltersOnPageLoad() {
    const vehicle = getSelectedVehicle();
    const onCollectionPage = getPageLoadCollectionPath();

    if (vehicle && !onCollectionPage) {
      const vehicleData = await fetchCollectionJsonData(vehicle, {
        collectionPath: DEFAULT_COLLECTION_PATH,
        updateLiveDom: true,
      });

      if (Array.isArray(vehicleData?.products)) {
        document.dispatchEvent(
          new CustomEvent('gr:collection-json-data', { detail: vehicleData })
        );
      }
    }

    applyVehicleFiltersToLinks();

    if (onCollectionPage && vehicle) {
      await scheduleSyncCollectionPageWithUniversalProducts();
    }

    console.log('[grGarage] initCollectionLinkFiltersOnPageLoad', {
      vehicle,
      onCollectionPage,
      appendFilters: shouldAppendVehicleFiltersToLinks(),
    });
  }

  // This function is used to exclude collection links that are not part of the vehicle filters.
  function isExcludedCollectionLink(link) {
    return !!link.closest('facet-remove') || !!link.closest('.pagination');
  }

  // This function is used to apply the vehicle filters to the collection links.
  function applyVehicleFiltersToLinks(root = document) {
    const vehicle = getSelectedVehicle();
    const appendFilters = shouldAppendVehicleFiltersToLinks();
    const links = root.querySelectorAll('a[href*="/collections/"]');

    links.forEach((a) => {
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

      if (!a.dataset.grOriginalHref) a.dataset.grOriginalHref = href;

      if (isExcludedCollectionLink(a)) {
        if (href !== a.dataset.grOriginalHref) {
          a.setAttribute('href', a.dataset.grOriginalHref);
        }
        return;
      }

      const nextHref = vehicle && appendFilters
        ? appendVehicleToCollectionUrl(a.dataset.grOriginalHref, vehicle)
        : a.dataset.grOriginalHref;

      if (nextHref && nextHref !== href) a.setAttribute('href', nextHref);
    });
  }

  // This function is used to initialize the collection link vehicle filters.
  function initCollectionLinkVehicleFilters() {
    applyVehicleFiltersToLinks();

    document.addEventListener(
      'click',
      (e) => {
        const vehicle = getSelectedVehicle();
        if (!vehicle) return;

        const link = e.target.closest('a[href*="/collections/"]');
        if (!link) return;
        if (isExcludedCollectionLink(link)) return;
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (link.target === '_blank' || link.hasAttribute('download')) return;

        const href = link.getAttribute('href');
        if (!href) return;

        const nextHref = appendVehicleToCollectionUrl(
          link.dataset.grOriginalHref || href,
          vehicle
        );
        if (!nextHref || nextHref === href) return;

        e.preventDefault();
        window.location.assign(nextHref);
      },
      true
    );

    document.addEventListener('gr:vehicle-added', () => {
      _lastCollectionJsonData = null;
      _resolvedUniversalCollectionPath = null;
      renderCompatibilityBanners();
      renderColMakeModal();
      if (getPageLoadCollectionPath()) {
        scheduleSyncCollectionPageWithUniversalProducts();
      }
    });
    document.addEventListener('gr:vehicle-cleared', async () => {
      _lastCollectionJsonData = null;
      _resolvedUniversalCollectionPath = null;
      applyVehicleFiltersToLinks();
      renderCompatibilityBanners();
      renderColMakeModal();
    });
    document.addEventListener('collection:product-filters', () => {
      const countEl = document.getElementById('ProductCount');
      if (countEl) delete countEl.dataset.grInitialVehicleCount;

      applyVehicleFiltersToLinks();
      renderCompatibilityBanners();
      scheduleSyncCollectionPageWithUniversalProducts();
    });
  }

  // This function is used to open the success modal.
  function openSuccessModal(vehicle, mode) {
    _lastSavedVehicle = vehicle || null;

    if (mode === 'loggedin') {
      if (modalBodyEl) modalBodyEl.innerHTML = 'Your choice has been saved!';
      if (modalLoginEl) modalLoginEl.style.display = 'none';
    } else {
      if (modalBodyEl)
        modalBodyEl.innerHTML =
          'Your choice has been saved for the current session.<br>Please log in to save it permanently';
      if (modalLoginEl) modalLoginEl.style.display = '';
    }

    if (modalOverlayEl) modalOverlayEl.classList.add('gr_g_show');
  }

  // This function is used to close the success modal.
  function closeSuccessModal() {
    if (modalOverlayEl) modalOverlayEl.classList.remove('gr_g_show');
    if (typeof window.closeOverlay === 'function') window.closeOverlay();

    // TODO: Uncomment this If we want to redirect to the selected vehicle page on Add Vehicle success.
    // if (_lastSavedVehicle) {
    //   window.location.href = buildFilterUrl(_lastSavedVehicle);
    //  _lastSavedVehicle = null;
    // }
  }

  // This function is used to dismiss the success modal.
  function dismissSuccessModal() {
    if (modalOverlayEl) modalOverlayEl.classList.remove('gr_g_show');
    if (typeof window.closeOverlay === 'function') window.closeOverlay();
    _lastSavedVehicle = null;
  }

  // This function is used to add event listeners to the success modal.
  if (modalXEl) modalXEl.addEventListener('click', closeSuccessModal);
  if (modalCloseEl) modalCloseEl.addEventListener('click', closeSuccessModal);
  if (modalOverlayEl) {
    modalOverlayEl.addEventListener('click', function (e) {
      if (e.target === modalOverlayEl) closeSuccessModal();
    });
  }

  const DUPLICATE_MESSAGE = 'A Vehicle with this make, model, and year already exists in your Garage.';

  // This function is used to set the message.
  function setMessage(text, tone) {
    if (!messageEl) return;
    messageEl.textContent = text || '';
    messageEl.classList.remove('gr_g_show', 'gr_g_error', 'gr_g_warning');
    if (!text) return;
    messageEl.classList.add('gr_g_show', tone === 'warning' ? 'gr_g_warning' : 'gr_g_error');
  }

  // This function is used to clear the message.
  function clearMessage() {
    setMessage('');
  }

  // This function is used to set the select.
  function setSelect(el, items, placeholder, disabled) {
    el.disabled = disabled;
    el.innerHTML =
      `<option value="">${placeholder}</option>` +
      (items || []).map(([l, v]) => `<option value="${v}">${l}</option>`).join('');
    el.classList.remove('gr_g_has-value');
  }

  // This function is used to handle the make change.
  function onMakeChange() {
    clearMessage();
    const make = makeEl.value;
    makeEl.classList.toggle('gr_g_has-value', !!make);
    const models = make && VEHICLES[make] ? Object.keys(VEHICLES[make]).map((m) => [m, m]) : null;
    setSelect(modelEl, models, 'Select', !models);
    setSelect(yearEl, null, 'Select', true);
    addBtnEl.disabled = true;
  }

  // This function is used to handle the model change.
  function onModelChange() {
    clearMessage();
    const make = makeEl.value;
    const model = modelEl.value;
    modelEl.classList.toggle('gr_g_has-value', !!model);
    const entry = model && VEHICLES[make]?.[model];
    const years = entry ? getYears(entry).map((y) => [y, y]) : null;
    setSelect(yearEl, years, 'Select', !years);
    addBtnEl.disabled = true;
  }

  // This function is used to handle the year change.
  function onYearChange() {
    clearMessage();
    const year = yearEl.value;
    yearEl.classList.toggle('gr_g_has-value', !!year);
    addBtnEl.disabled = !year || addBtnEl.textContent === 'Adding...';
  }

  // This function is used to open the drawer.
  function openDrawer() {
    clearMessage();
    backdropEl.classList.add('gr_g_show');
    drawerEl.classList.add('gr_g_open');
    document.body.style.overflow = 'hidden';
  }

  // This function is used to close the drawer.
  function closeDrawer() {
    backdropEl.classList.remove('gr_g_show');
    drawerEl.classList.remove('gr_g_open');
    document.body.style.overflow = '';
    clearMessage();
    _replaceMode = false;
    if (typeof window.closeOverlay === 'function') window.closeOverlay();
  }

  // This function is used to reset the form.
  function resetForm() {
    clearMessage();
    setSelect(
      makeEl,
      Object.keys(VEHICLES).map((m) => [m, m]),
      'Select',
      false
    );
    setSelect(modelEl, null, 'Select', true);
    setSelect(yearEl, null, 'Select', true);
    addBtnEl.disabled = true;
  }

  // This function is used to get the stored vehicles.
  function getStoredVehicles() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  // This function is used to save the vehicle to local storage.
  function saveVehicleToLocalStorage(vehicle) {
    const entry = {
      id: `local_${Date.now()}`,
      make: vehicle.make,
      model: vehicle.model,
      year: vehicle.year,
      addedAt: new Date().toISOString(),
    };

    if (_replaceMode) {
      _replaceMode = false;
      localStorage.setItem(STORAGE_KEY, JSON.stringify([entry]));
      return { success: true, duplicate: false };
    }

    const vehicles = getStoredVehicles();
    const exists = vehicles.some(
      (v) => v.make === vehicle.make && v.model === vehicle.model && String(v.year) === String(vehicle.year)
    );
    if (exists) return { success: false, duplicate: true };

    vehicles.push(entry);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicles));
    return { success: true, duplicate: false };
  }

  // This function is used to save the vehicle to the API.
  async function saveVehicleToApi(vehicle, markAsDefault = false) {
    const payload = {
      make: vehicle.make,
      model: vehicle.model,
      year: vehicle.year,
      ...(markAsDefault ? { markAsDefault: true } : {}),
    };

    const response = await fetch(`${API_URL}/garage/add`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok || (data.statusCode && data.statusCode !== 200)) {
      const error = new Error(
        data.message || data.details?.[0]?.message || 'Failed to save vehicle. Please try again.'
      );
      error.statusCode = data.statusCode || response.status;
      throw error;
    }
    return data;
  }

  // This function is used to set the add loading.
  function setAddLoading(isLoading) {
    addBtnEl.disabled = isLoading || !yearEl.value;
    addBtnEl.textContent = isLoading ? 'Adding...' : 'Add Vehicle';
  }

  // This function is used to handle the add.
  async function handleAdd() {
    const make = makeEl.value;
    const model = modelEl.value;
    const year = yearEl.value;
    if (!make || !model || !year) return;

    const vehicle = { make, model, year };
    clearMessage();
    setAddLoading(true);

    try {
      if (CONFIG.isLoggedIn) {
        await saveVehicleToApi(vehicle, false);
        resetForm();
        closeDrawer();
        openSuccessModal(vehicle, 'loggedin');
        await fetchGarageList();
        renderAll();
      } else {
        const result = saveVehicleToLocalStorage(vehicle);
        if (result.duplicate) {
          setMessage(DUPLICATE_MESSAGE, 'warning');
          return;
        }
        resetForm();
        closeDrawer();
        renderAll();
        document.dispatchEvent(new CustomEvent('gr:vehicle-added', { detail: { vehicle } }));
        await syncCollectionJsonDataOnVehicleSelection(vehicle, { redirect: true });
        return;
      }
      document.dispatchEvent(new CustomEvent('gr:vehicle-added', { detail: { vehicle } }));
    } catch (error) {
      console.error('Garage: failed to save vehicle', error);
      if (error.statusCode === 409) {
        setMessage(error.message || DUPLICATE_MESSAGE, 'warning');
      } else {
        setMessage(error.message || 'Failed to save vehicle. Please try again.', 'error');
      }
    } finally {
      setAddLoading(false);
    }
  }

  // This function is used to add event listeners to the make, model, and year select.
  makeEl.addEventListener('change', onMakeChange);
  modelEl.addEventListener('change', onModelChange);
  yearEl.addEventListener('change', onYearChange);

  // This function is used to add event listeners to the data-gr-g-action attribute.
  document.querySelectorAll('[data-gr-g-action]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const action = el.getAttribute('data-gr-g-action');
      if (action === 'open') openDrawer();
      else if (action === 'close') closeDrawer();
      else if (action === 'add') handleAdd();
    });
  });

  // This function is used to set the select.
  setSelect(
    makeEl,
    Object.keys(VEHICLES).map((m) => [m, m]),
    'Select',
    false
  );

  /* ── Compatibility banner ── */
  const COMPAT_CHECK_SVG = `<svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Zm11.315 5.137 6.91-8.637-1.25-1-5.89 7.363-4.173-3.478-1.024 1.23 5.427 4.522Z" clip-rule="evenodd"></path>
      </svg>`;
  const COMPAT_X_SVG = `<svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Zm16.234 5.366L12 13.13l-4.234 4.235-1.132-1.132L10.87 12 6.634 7.766l1.132-1.132L12 10.87l4.234-4.235 1.132 1.132L13.13 12l4.235 4.234-1.132 1.132Z" clip-rule="evenodd"></path>
    </svg>`;

  // This function is used to normalize the compatibility data.
  function normalizeCompatData(data) {
    const toArr = (v) => {
      if (Array.isArray(v)) return v.map(String).filter((s) => s.trim() !== '');
      if (v === '' || v == null) return [];
      return [String(v)];
    };
    return {
      make: toArr(data?.make),
      model: toArr(data?.model),
      year: toArr(data?.year),
    };
  }

  // This function is used to check if the compatibility is universal.
  function isUniversalCompat(compat) {
    return !compat.make.length && !compat.model.length && !compat.year.length;
  }

  // This function is used to check if the vehicle matches the compatibility.
  function vehicleMatchesCompat(compat, vehicle) {
    return (
      compat.make.some((m) => m.toLowerCase() === vehicle.make.toLowerCase()) &&
      compat.model.some((m) => m.toLowerCase() === vehicle.model.toLowerCase()) &&
      compat.year.some((y) => String(y) === String(vehicle.year))
    );
  }

  function hasUniversalTag(tags) {
    return Array.isArray(tags) && tags.some((t) => typeof t === 'string' && (t.toLowerCase() === 'universal' || t.toLowerCase() === 'universal-fit'));
  }

  function parseCardDataset(el) {
    let compat = { make: [], model: [], year: [] };
    let tags = [];
    try {
      compat = normalizeCompatData(JSON.parse(el.dataset.vehicle || '{}'));
    } catch {
      return null;
    }
    try {
      tags = JSON.parse(el.dataset.tags || '[]');
    } catch {
      tags = [];
    }
    return { compat, tags };
  }

  function buildCardCompatHtml(type, vehicleLabel) {
    const configs = {
      compatible: {
        modifier: 'gr_g_compat--compatible',
        icon: COMPAT_CHECK_SVG,
        text: `This part fits your ${vehicleLabel}`,
      },
      not: {
        modifier: 'gr_g_compat--not',
        icon: COMPAT_X_SVG,
        text: `This part doesn't fit your ${vehicleLabel}`,
      },
      universal: {
        modifier: 'gr_g_compat--universal',
        icon: COMPAT_CHECK_SVG,
        text: 'This part is universally compatible with most vehicles',
      },
      'no-vehicle': {
        modifier: 'gr_g_compat--no-vehicle',
        icon: COMPAT_CHECK_SVG,
        text: 'Select your vehicle to check compatibility',
      },
    };
    const cfg = configs[type];
    if (!cfg) return '';

    return `
        <div class="gr_g_compat gr_g_compat_card ${cfg.modifier}">
          <span class="gr_g_compat_icon">${cfg.icon}</span>
          <span class="gr_g_compat_card_text">${cfg.text}</span>
        </div>`;
  }

  function getCardCompatType(compat, tags, vehicle) {
    if (isUniversalCompat(compat)) return 'universal';
    if (!vehicle) return 'no-vehicle';

    if (vehicleMatchesCompat(compat, vehicle)) return 'compatible';
    if (hasUniversalTag(tags)) return 'universal';
    return 'not';
  }

  function renderCardCompatibilityBanners(root = document) {
    const roots = root.querySelectorAll('.gr_g_compat_card_root');
    if (!roots.length) return;

    const vehicle = getSelectedVehicle();
    const vehicleLabel = vehicle ? `${vehicle.year} ${vehicle.make} ${vehicle.model}` : '';

    roots.forEach((el) => {
      const parsed = parseCardDataset(el);
      if (!parsed) {
        el.innerHTML = '';
        return;
      }

      const { compat, tags } = parsed;
      const type = getCardCompatType(compat, tags, vehicle);
      el.innerHTML = buildCardCompatHtml(type, vehicleLabel);
    });
  }

  /** Rerender PDP (.gr_g_compat_root) and product card (.gr_g_compat_card_root) banners. */
  function renderCompatibilityBanners(root = document) {
    renderCompatibilityBanner();
    renderCardCompatibilityBanners(root);
  }

  function renderCompatibilityBanner() {
    const els = document.querySelectorAll('.gr_g_compat_root');
    if (!els.length) return;

    const compat = window.grGarageConfig?.compatibility;

    // Build the HTML to inject (same for every instance).
    let html = '';
    let hide = false;

    if (!compat) {
      hide = true;
    } else if (isUniversalCompat(normalizeCompatData(compat))) {
      // Universal
      html = `
          <div class="gr_g_compat gr_g_compat--universal">
            <span class="gr_g_compat_icon">${COMPAT_CHECK_SVG}</span>
            <span>
              <span class="gr_g_compat_label">Universal</span>
              <span class="gr_g_compat_desc">This part is universally compatible with most vehicles</span>
            </span>
          </div>`;
    } else {
      // Resolve the currently selected vehicle.
      let vehicle = null;
      if (CONFIG.isLoggedIn) {
        vehicle = _apiVehicles.find((v) => v.markAsDefault) || null;
      } else {
        const stored = getStoredVehicles();
        vehicle = stored[stored.length - 1] || null;
      }

      if (!vehicle) {
        html = `
            <div class="gr_g_compat gr_g_compat--no-vehicle">
              <span class="gr_g_compat_icon">${COMPAT_CHECK_SVG}</span>
              <span>
                <span class="gr_g_compat_label">Select your vehicle</span>
                <span class="gr_g_compat_desc">To see if this part works with your vehicle, please select your vehicle</span>
              </span>
            </div>`;
      } else {
        const compatData = normalizeCompatData(compat);
        const makeArr = compatData.make;
        const modelArr = compatData.model;
        const yearArr = compatData.year;

        const matches = vehicleMatchesCompat(compatData, vehicle);

        const vehicleLabel = `${vehicle.year} ${vehicle.make} ${vehicle.model}`;

        if (matches) {
          html = `
              <div class="gr_g_compat gr_g_compat--compatible">
                <span class="gr_g_compat_icon">${COMPAT_CHECK_SVG}</span>
                <span>
                  <span class="gr_g_compat_label">Compatible</span>
                  <span class="gr_g_compat_desc">This part fits your ${vehicleLabel}</span>
                </span>
              </div>`;
        } else {
          const tags = Array.isArray(window.grGarageConfig?.productTags) ? window.grGarageConfig.productTags : [];
          const isUniversalTag = hasUniversalTag(tags);
          if (isUniversalTag) {
            html = `
                <div class="gr_g_compat gr_g_compat--universal">
                  <span class="gr_g_compat_icon">${COMPAT_CHECK_SVG}</span>
                  <span>
                    <span class="gr_g_compat_label">Universal</span>
                    <span class="gr_g_compat_desc">This part is universally compatible with most vehicles</span>
                  </span>
                </div>`;
          } else {
            html = `
                <div class="gr_g_compat gr_g_compat--not">
                  <span class="gr_g_compat_icon">${COMPAT_X_SVG}</span>
                  <span>
                    <span class="gr_g_compat_label">Not Compatible</span>
                    <span class="gr_g_compat_desc">This part doesn't fit your ${vehicleLabel}</span>
                  </span>
                </div>`;
          }
        }
      }
    }

    // Apply to every instance on the page.
    els.forEach((el) => {
      if (hide) {
        el.innerHTML = '';
        el.style.display = 'none';
      } else {
        el.style.display = '';
        el.innerHTML = html;
      }
    });
  }

  /* ── Garage link button ── */
  function renderGarageLink() {
    const els = document.querySelectorAll('.gr_g_garage_link_root');
    if (!els.length) return;

    if (CONFIG.isLoggedIn) {
      // ── Logged-in ──
      const def = _apiVehicles.find((v) => v.markAsDefault) || _apiVehicles[0] || null;

      if (!def) {
        // No vehicles yet — "Select Your Vehicle"
        els.forEach((el) => {
          el.style.display = '';
          el.innerHTML = `
              <button class="gr_g_indicator gr_g_indicator--empty" type="button" data-gr-glink="select">
                <span class="gr_g_indicator-icon">${CAR_ICON_SVG}</span>
                <span class="gr_g_indicator-label">Select Your Vehicle</span>
              </button>`;
          el.querySelector('[data-gr-glink="select"]').addEventListener('click', openDrawer);
        });
      } else {
        // Has vehicles — garage page link
        const firstName = window.grGarageConfig?.customerFirstName || '';
        const label = firstName ? `${firstName}'s Garage` : 'My Garage';
        els.forEach((el) => {
          el.style.display = '';
          el.innerHTML = `
              <a class="gr_g_garage_link" href="${GARAGE_PAGE_URL}" aria-label="${label}">
                ${CAR_ICON_SVG}
                <span>${label}</span>
              </a>`;
        });
      }

    } else {
      // ── Guest ──
      const stored = getStoredVehicles();
      const latest = stored[stored.length - 1];

      if (!latest) {
        // No vehicle — "Select Your Vehicle"
        els.forEach((el) => {
          el.style.display = '';
          el.innerHTML = `
              <button class="gr_g_indicator gr_g_indicator--empty" type="button" data-gr-glink="select">
                <span class="gr_g_indicator-icon">${CAR_ICON_SVG}</span>
                <span class="gr_g_indicator-label">Select Your Vehicle</span>
              </button>`;
          el.querySelector('[data-gr-glink="select"]').addEventListener('click', openDrawer);
        });
      } else {
        // Vehicle saved — show vehicle name + badge count + Change button
        const vehicleLabel = `${latest.year} ${latest.make} ${latest.model}`;
        const count = stored.length;
        els.forEach((el) => {
          el.style.display = '';
          el.innerHTML = `
              <div class="gr_g_indicator gr_g_indicator--filled">
                <span class="gr_g_indicator-icon-wrap">
                  ${CAR_ICON_SVG}
                  // ${count > 0 ? `<span class="gr_g_indicator-badge">${count}</span>` : ''}
                </span>
                <span class="gr_g_indicator-vehicle">${vehicleLabel}</span>
                <span class="gr_g_indicator-divider" aria-hidden="true"></span>
                <button class="gr_g_indicator-change" type="button" data-gr-glink="change">Change</button>
              </div>`;
          el.querySelector('[data-gr-glink="change"]').addEventListener('click', _openGuestChangeModal);
        });
      }
    }
  }

  function renderAll() {
    renderVehicleIndicator();
    renderVehicleBar();
    renderColMakeModal();
    renderCompatibilityBanners();
    renderGarageLink();
    applyVehicleFiltersToLinks();
  }

  /**
   * addVehicle({ make, model, year, markAsDefault, skipModal, redirect })
   * Programmatically add a vehicle with the same guest/logged-in logic as the drawer.
   *
   * markAsDefault — logged-in only; defaults to true (selects new vehicle, unselects others)
   * skipModal     — skip the success popup (defaults to false)
   * redirect      — redirect to filtered collection after success (defaults to false)
   * replace       — guest only; replace existing localStorage vehicle instead of appending (defaults to false)
   *
   * Returns:
   *   { success: true,  data: <api response or localStorage entry> }  on success
   *   { success: false, duplicate: true }                              on duplicate
   *   { success: false, error: Error }                                 on failure
   */
  async function addVehicle({ make, model, year, markAsDefault = true, skipModal = false, redirect = false, replace = false } = {}) {
    // ── Validation ──
    if (!make || typeof make !== 'string' || !make.trim()) {
      return { success: false, error: new Error('make is required') };
    }
    if (!model || typeof model !== 'string' || !model.trim()) {
      return { success: false, error: new Error('model is required') };
    }
    if (!year || (typeof year !== 'string' && typeof year !== 'number') || !String(year).trim()) {
      return { success: false, error: new Error('year is required') };
    }

    const vehicle = { make: make.trim(), model: model.trim(), year: String(year).trim() };

    try {
      if (CONFIG.isLoggedIn) {
        const data = await saveVehicleToApi(vehicle, markAsDefault === true);
        await fetchGarageList();
        renderAll();
        _renderGarageList();
        if (!skipModal) openSuccessModal(vehicle, 'loggedin');
        document.dispatchEvent(new CustomEvent('gr:vehicle-added', { detail: { vehicle } }));
        if (redirect) await syncCollectionJsonDataOnVehicleSelection(vehicle, { redirect: true });
        return { success: true, data };
      } else {
        if (replace) _replaceMode = true;
        const result = saveVehicleToLocalStorage(vehicle);
        if (result.duplicate) {
          if (redirect) {
            await syncCollectionJsonDataOnVehicleSelection(vehicle, { redirect: true });
            return { success: true, duplicate: true, data: vehicle };
          }
          return { success: false, duplicate: true };
        }
        renderAll();
        if (!skipModal) openSuccessModal(vehicle, 'guest');
        document.dispatchEvent(new CustomEvent('gr:vehicle-added', { detail: { vehicle } }));
        if (redirect) await syncCollectionJsonDataOnVehicleSelection(vehicle, { redirect: true });
        return { success: true, data: vehicle };
      }
    } catch (err) {
      if (err.statusCode === 409 && CONFIG.isLoggedIn) {
        try {
          const selected = await _selectExistingVehicle(vehicle);
          document.dispatchEvent(new CustomEvent('gr:vehicle-added', { detail: { vehicle } }));
          if (redirect) await syncCollectionJsonDataOnVehicleSelection(vehicle, { redirect: true });
          return { success: true, duplicate: true, data: selected };
        } catch (selectErr) {
          return { success: false, error: selectErr };
        }
      }
      if (err.statusCode === 409) {
        if (redirect) {
          await syncCollectionJsonDataOnVehicleSelection(vehicle, { redirect: true });
          return { success: true, duplicate: true, data: vehicle };
        }
        return { success: false, duplicate: true };
      }
      return { success: false, error: err };
    }
  }

  window.grGarage = {
    openDrawer,
    fetchGarageList,
    renderVehicleIndicator,
    renderVehicleBar,
    renderColMakeModal,
    renderCompatibilityBanner,
    renderCardCompatibilityBanners,
    renderCompatibilityBanners,
    renderGarageLink,
    renderAll,
    addVehicle,
    getSelectedVehicle,
    appendVehicleToCollectionUrl,
    applyVehicleFiltersToLinks,
    buildFilterUrl,
    buildCollectionDataFetchUrl,
    buildPageLoadCollectionFetchUrl,
    fetchCollectionJsonData,
    fetchCollectionJsonDataForPageLoad,
    parseCollectionJsonDataFromHtml,
    syncCollectionJsonDataOnVehicleSelection,
    resolveVehicleCollectionRedirectUrl,
    initCollectionLinkFiltersOnPageLoad,
    notifyVehicleCleared,
    syncCollectionPageWithUniversalProducts,
    scheduleSyncCollectionPageWithUniversalProducts,
    fetchUniversalCollectionJson,
    updateProductCountDisplay,
    getLastCollectionProducts(vehicle) {
      if (!vehicle || !Array.isArray(_lastCollectionJsonData?.products)) return null;
      return _lastCollectionJsonData.products;
    },
  };

  document.dispatchEvent(new CustomEvent('gr:garage-ready'));

  async function initGarageApp() {
    initCollectionLinkVehicleFilters();

    if (CONFIG.isLoggedIn) {
      await fetchGarageList();
    }

    renderAll();

    _garageInitSettled = true;
    document.dispatchEvent(
      new CustomEvent('gr:garage-initialized', {
        detail: { vehicle: getSelectedVehicle() },
      })
    );

    initCollectionLinkFiltersOnPageLoad().catch((err) => {
      console.error('[grGarage] initCollectionLinkFiltersOnPageLoad failed', err);
    });
  }

  initGarageApp();

  // Merge local vehicles if logged in
  (async function mergeLocalVehiclesIfLoggedIn() {
    if (!CONFIG.isLoggedIn) return;

    const stored = getStoredVehicles() || [];
    if (!stored.length) return;

    try {
      const response = await fetch(`${API_URL}/garage/merge`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vehicles: stored?.map(({ make, model, year }) => ({ make, model, year })),
        }),
      });

      const data = await response.json().catch(() => ({}));
      if (response.ok && (!data.statusCode || data.statusCode === 200)) {
        localStorage.removeItem(STORAGE_KEY);
        await fetchGarageList();
        renderAll();
        await initCollectionLinkFiltersOnPageLoad();
        _garageInitSettled = true;
        document.dispatchEvent(
          new CustomEvent('gr:garage-initialized', {
            detail: { vehicle: getSelectedVehicle() },
          })
        );
      }
    } catch (err) {
      console.warn('Garage: background merge failed', err);
    }
  })();

  /* ── Selected vehicle recommendations ── */
  const DEFAULT_CARD_CLASS = 'color-background-1';
  const EVENT_CONTEXT = 'CustomRelatedProductsSection';

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function truncate(text, max = 125) {
    const value = String(text || '');
    return value.length > max ? `${value.slice(0, max)}...` : value;
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }

    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    }).format(amount);
  }

  function getRelatedProductsLayoutClasses(count) {
    const total = Math.max(0, Number(count) || 0);
    let classes = 'grid';

    switch (total) {
      case 1:
        classes += ' grid-1-col grid-2-col-tablet grid-4-col-desktop';
        break;
      case 2:
        classes += ' grid-2-col-tablet grid-4-col-desktop';
        break;
      case 3:
        classes += ' grid-3-col-tablet grid-3-col-desktop';
        break;
      case 4:
        classes += ' grid-3-col-tablet grid-4-col-desktop';
        break;
      default:
        if (total >= 5) classes += ' grid-3-col-tablet grid-5-col-desktop grid-compact';
        break;
    }

    return classes;
  }

  function buildSaleBadge(product) {
    const price = Number(product.price || 0);
    const compareAt = Number(product.compare_at_price || 0);
    if (!compareAt || compareAt <= price) return '';

    const percentage = Math.round(((compareAt - price) / compareAt) * 100);
    return `
          <div class="card-badge top left">
            <span class="badge badge-sale">-${percentage}%</span>
          </div>
        `;
  }

  function buildStockBadge(product, showStock) {
    if (!showStock) return '';

    if (product.available) {
      return `
            <div class="badge-stock badge-stock-in">
              <span class="badge-stock-dot"></span> In stock
            </div>
          `;
    }

    return `
          <div class="badge-stock badge-stock-out">
            <span class="badge-stock-dot"></span> Out of stock
          </div>
        `;
  }

  function buildPriceHtml(product) {
    const price = Number(product.price || 0);
    const compareAt = Number(product.compare_at_price || 0);
    const onSale = compareAt > price;

    return `
          <div class="price${onSale ? ' price-on-sale' : ''}${product.available === false ? ' price-sold-out' : ''}">
            <div class="price-container veeper_items" data-pid="${product.id}">
              <div class="price-regular">
                <span class="visually-hidden">Regular price</span>
                <span class="price-item price-item-regular">${formatMoney(price)}</span>
              </div>
              ${onSale
        ? `
                <div class="price-sale">
                  <span class="visually-hidden">Sale price</span>
                  <span>
                    <s class="price-item price-item-regular">${formatMoney(compareAt)}</s>
                  </span>
                  <span class="visually-hidden">Regular price</span>
                  <span class="price-item price-item-sale">${formatMoney(price)}</span>
                </div>
              `
        : ''
      }
            </div>
          </div>
        `;
  }

  function buildAddToCartHtml(product, settings) {
    if (!settings.showAddToCart) return '';

    const url = product.url || `/products/${product.handle}`;
    const label = product.available ? 'View product' : 'Out of stock';

    return `
          <div class="product-actions card-product-actions">
            <div class="product-actions-add-to-cart">
              <a href="${escapeHtml(url)}" class="button button-primary"${product.available ? '' : ' aria-disabled="true" role="link"'}>
                ${label}
              </a>
            </div>
          </div>
        `;
  }

  function buildCompatCardRootHtml(product) {
    const vehiclePayload = JSON.stringify({
      make: product?.make ?? '',
      model: product?.vehicle_model ?? '',
      year: product?.vehicle_year ?? '',
    });
    const tagsPayload = JSON.stringify(Array.isArray(product?.tags) ? product.tags : []);

    return `
            <div
              class="gr_g_compat_card_root"
              data-vehicle='${vehiclePayload}'
              data-tags='${tagsPayload}'
            ></div>
          `;
  }

  function renderRelatedProductCard(product, settings = {}) {
    if (!product) return '';

    const {
      showVendor = true,
      showStock = true,
      showRating = false,
      cardClass = DEFAULT_CARD_CLASS,
    } = settings;

    const title = truncate(product.title);
    const url = product.url || `/products/${product.handle}`;
    const image = product.featured_image || '';
    const vendor = product.vendor ? escapeHtml(product.vendor) : '';

    return `
          <div class="card card-product${image ? '' : ' card-no-media'} ${escapeHtml(cardClass)}">
            <figure class="card-media">
              <a href="${escapeHtml(url)}">
                ${image
        ? `
                  <div class="aspect-ratio" style="--ratio-percent: 100%;">
                    <img
                      src="${escapeHtml(image)}"
                      alt="${escapeHtml(title)}"
                      class="card-media-image"
                      loading="lazy"
                      width="420"
                      height="420"
                    >
                  </div>
                `
        : ''
      }
              </a>
              ${buildSaleBadge(product)}
            </figure>

            <div class="card-info">
              ${showVendor && vendor
        ? `<div class="card-eyebrow"><span>${vendor}</span></div>`
        : ''
      }
              <h3 class="card-heading">
                <a href="${escapeHtml(url)}">${escapeHtml(title)}</a>
              </h3>
            </div>

            <div class="card-footer">
              <div class="card-footer-intro">
                ${buildStockBadge(product, showStock)}
                ${showRating ? '<div class="rating-placeholder"></div>' : ''}
              </div>
              ${buildCompatCardRootHtml(product)}
              ${buildPriceHtml(product)}
              ${buildAddToCartHtml(product, settings)}
            </div>
          </div>
        `;
  }

  function normalizeRecommendationProducts(products) {
    if (!Array.isArray(products)) return [];
    return products.filter((product) => product && product.id && product.handle);
  }

  const METAFIELD_RECOMMENDATIONS_MAX = 3;

  function normalizeProductType(value) {
    return String(value || '').trim().toLowerCase();
  }

  function matchesProductTypeFilter(product, currentProductType, matchMode) {
    const mode = String(matchMode || 'any').toLowerCase();
    if (mode === 'any') return true;

    const current = normalizeProductType(currentProductType);
    const candidate = normalizeProductType(product?.type || product?.product_type);

    if (!current || !candidate) return true;

    if (mode === 'same') return candidate === current;
    if (mode === 'different') return candidate !== current;

    return true;
  }

  function pickRecommendationProducts(products, options = {}) {
    const {
      currentHandle = '',
      limit = 0,
      excludeHandles = [],
      currentProductType = '',
      productTypeMatch = 'any',
      applyProductTypeFilter = false,
    } = options;

    const excluded = new Set(
      [currentHandle, ...excludeHandles]
        .filter(Boolean)
        .map((handle) => String(handle).toLowerCase())
    );

    const picked = [];
    const maxCount = Math.max(0, Number(limit) || 0);

    for (const product of normalizeRecommendationProducts(products)) {
      if (picked.length >= maxCount) break;

      const handle = String(product.handle || '').toLowerCase();
      if (!handle || excluded.has(handle) || handle.includes('navidium')) continue;

      if (
        applyProductTypeFilter &&
        !matchesProductTypeFilter(product, currentProductType, productTypeMatch)
      ) {
        continue;
      }

      excluded.add(handle);
      picked.push(product);
    }

    return picked;
  }

  function buildMergedRecommendationProducts(settings, collectionProducts = []) {
    const maxTotal = Math.max(1, Number(settings.limit) || 4);
    const maxMfSlots = Math.min(METAFIELD_RECOMMENDATIONS_MAX, Math.max(0, maxTotal - 1));

    const mfProducts = pickRecommendationProducts(settings.selectedVehicleMfProducts || [], {
      currentHandle: settings.currentHandle,
      limit: maxMfSlots,
    });

    const remaining = maxTotal - mfProducts.length;
    const collectionPart =
      remaining > 0
        ? pickRecommendationProducts(collectionProducts, {
            currentHandle: settings.currentHandle,
            limit: remaining,
            excludeHandles: mfProducts.map((product) => product.handle),
            currentProductType: settings.currentProductType,
            productTypeMatch: settings.collectionProductTypeMatch,
            applyProductTypeFilter: true,
          })
        : [];

    return [...mfProducts, ...collectionPart];
  }

  function filterRecommendationProducts(products, options = {}) {
    const { limit = 4 } = options;
    return pickRecommendationProducts(products, {
      ...options,
      limit: Math.max(1, Number(limit) || 4),
    });
  }

  function renderSelectedVehicleRecommendations(root, products, settings = {}) {
    const grid = root.querySelector('[data-gr-related-grid]');
    if (!grid) return { count: 0, layoutClasses: getRelatedProductsLayoutClasses(0) };

    const filtered = Array.isArray(products) ? products : [];

    const layoutClasses = getRelatedProductsLayoutClasses(filtered.length);
    grid.className = layoutClasses;
    grid.innerHTML = filtered
      .map(
        (product) => `
              <li class="grid-item">
                ${renderRelatedProductCard(product, settings)}
              </li>
            `
      )
      .join('');

    return { count: filtered.length, layoutClasses, products: filtered };
  }

  async function fetchVehicleCollectionProducts() {
    const vehicle = getSelectedVehicle();
    if (!vehicle) return [];

    const data = await fetchCollectionJsonData(vehicle, {
      collectionPath: '/collections/all',
      updateLiveDom: false,
    });

    return normalizeRecommendationProducts(data?.products);
  }

  function parseJsonDataset(raw, fallback = []) {
    if (!raw) return fallback;
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : fallback;
    } catch (err) {
      console.warn('Garage: failed to parse dataset JSON', err);
      return fallback;
    }
  }

  function readSettings(element) {
    return {
      limit: Number(element.dataset.limit || 4),
      showVendor: element.dataset.showVendor !== 'false',
      showStock: element.dataset.showStock !== 'false',
      showRating: element.dataset.showRating === 'true',
      showAddToCart: element.dataset.showAddToCart !== 'false',
      isWholesale: element.dataset.isWholesale === 'true',
      currentHandle: element.dataset.productHandle || '',
      currentProductType: element.dataset.productType || '',
      collectionProductTypeMatch: element.dataset.collectionProductTypeMatch || 'different',
      cardClass: element.dataset.cardClass || DEFAULT_CARD_CLASS,
      eventContext: element.dataset.eventContext || EVENT_CONTEXT,
      selectedVehicleMfProducts: parseJsonDataset(element.dataset.selectedVehicleMfProducts),
    };
  }

  if (!customElements.get('selected-vehicle-recommendations')) {
    class SelectedVehicleRecommendations extends HTMLElement {
      constructor() {
        super();
        this._refreshPromise = null;
        this._cachedCollectionProducts = null;
        this._onCollectionJsonData = this._onCollectionJsonData.bind(this);
        this._onVehicleChanged = this._onVehicleChanged.bind(this);
        this._scheduleRefresh = this._scheduleRefresh.bind(this);
      }

      connectedCallback() {
        this.hidden = true;
        document.addEventListener('gr:collection-json-data', this._onCollectionJsonData);
        document.addEventListener('gr:vehicle-added', this._onVehicleChanged);
        document.addEventListener('gr:vehicle-cleared', this._onVehicleChanged);
        document.addEventListener('gr:garage-initialized', this._onGarageInitialized);
        this._syncSectionVisibility();
        this._scheduleRefresh();
      }

      disconnectedCallback() {
        document.removeEventListener('gr:collection-json-data', this._onCollectionJsonData);
        document.removeEventListener('gr:vehicle-added', this._onVehicleChanged);
        document.removeEventListener('gr:vehicle-cleared', this._onVehicleChanged);
        document.removeEventListener('gr:garage-initialized', this._onGarageInitialized);
      }

      _getDefaultRelatedBlock() {
        return this.closest('[data-gr-related-products-switcher]')?.querySelector('[data-gr-default-related-products]')
          || this.closest('.container')?.querySelector('[data-gr-default-related-products]')
          || null;
      }

      _getSwitcherRoot() {
        return this.closest('[data-gr-related-products-switcher]') || null;
      }

      _markSwitcherReady() {
        const switcher = this._getSwitcherRoot();
        if (switcher) switcher.classList.add('is-ready');
      }

      _canRevealSwitcher() {
        if (!window.grGarageConfig?.isLoggedIn) return true;
        return _garageInitSettled || !!getSelectedVehicle();
      }

      _setRelatedBlocksVisibility(showVehicleRecs) {
        const defaultBlock = this._getDefaultRelatedBlock();
        if (defaultBlock) defaultBlock.hidden = !!showVehicleRecs;
        this.hidden = !showVehicleRecs;
        this._markSwitcherReady();
      }

      _syncSectionVisibility() {
        if (!this._canRevealSwitcher()) {
          const defaultBlock = this._getDefaultRelatedBlock();
          if (defaultBlock) defaultBlock.hidden = true;
          this.hidden = true;
          return;
        }

        if (!getSelectedVehicle()) {
          this._setRelatedBlocksVisibility(false);
        }
      }

      _onGarageInitialized() {
        this._syncSectionVisibility();
        this._scheduleRefresh();
      }

      _onVehicleChanged() {
        this._cachedCollectionProducts = null;
        this._syncSectionVisibility();
        this._scheduleRefresh();
      }

      _onCollectionJsonData(event) {
        const vehicle = getSelectedVehicle();
        if (!vehicle || !Array.isArray(event?.detail?.products)) return;

        this._cachedCollectionProducts = event.detail.products;
        this._scheduleRefresh();
      }

      _scheduleRefresh() {
        if (this._refreshPromise) return this._refreshPromise;

        this._refreshPromise = this._loadAndRender().finally(() => {
          this._refreshPromise = null;
        });

        return this._refreshPromise;
      }

      async _waitForGarageInit() {
        if (!window.grGarageConfig?.isLoggedIn || getSelectedVehicle() || _garageInitSettled) return;

        await new Promise((resolve) => {
          let settled = false;

          const finish = () => {
            if (settled) return;
            settled = true;
            cleanup();
            resolve();
          };

          const cleanup = () => {
            document.removeEventListener('gr:garage-initialized', finish);
            clearTimeout(timeoutId);
          };

          document.addEventListener('gr:garage-initialized', finish);
          const timeoutId = setTimeout(finish, 10000);
        });
      }

      async _getCollectionProducts(vehicle) {
        if (!vehicle) return [];

        if (Array.isArray(this._cachedCollectionProducts)) {
          return normalizeRecommendationProducts(this._cachedCollectionProducts);
        }

        const cachedProducts = window.grGarage?.getLastCollectionProducts?.(vehicle);
        if (Array.isArray(cachedProducts)) {
          this._cachedCollectionProducts = cachedProducts;
          return normalizeRecommendationProducts(cachedProducts);
        }

        return fetchVehicleCollectionProducts();
      }

      async _loadAndRender() {
        try {
          await this._waitForGarageInit();

          const vehicle = getSelectedVehicle();
          if (!vehicle) {
            this._setRelatedBlocksVisibility(false);
            return;
          }

          const settings = readSettings(this);
          const collectionProducts = await this._getCollectionProducts(vehicle);
          const products = buildMergedRecommendationProducts(settings, collectionProducts);

          this.render(products);
        } catch (error) {
          console.error('SelectedVehicleRecommendations: failed to load products', error);
          this._setRelatedBlocksVisibility(false);
        }
      }

      render(products) {
        const vehicle = getSelectedVehicle();
        if (!vehicle) {
          this._setRelatedBlocksVisibility(false);
          return;
        }

        const list = Array.isArray(products) ? products : [];
        if (!list.length) {
          this._setRelatedBlocksVisibility(false);
          return;
        }

        const settings = readSettings(this);
        const result = renderSelectedVehicleRecommendations(this, list, settings);
        this._setRelatedBlocksVisibility(result.count > 0);

        if (result.count > 0) {
          renderCompatibilityBanners(this);
        }
      }
    }

    customElements.define('selected-vehicle-recommendations', SelectedVehicleRecommendations);
  }

  window.grRelatedProducts = {
    getRelatedProductsLayoutClasses,
    renderRelatedProductCard,
    renderSelectedVehicleRecommendations,
    fetchVehicleCollectionProducts,
    buildMergedRecommendationProducts,
    pickRecommendationProducts,
    filterRecommendationProducts,
  };
})();
